import * as moment from 'moment';

import { TimeUnit } from '../models/';
import { getTimeZone } from './getTimezone';

export class DatesHelper {
    /// Slides a date according to a string (e.g. *-30d)
    slide(date, value: string): Date {
        let computedDate = date;
        const length = value.length;
        if (length > 1 && date) {
            let unit = value[length - 1];
            const time = value.substring(1, length - 1);
            if (unit === 'm' || unit === 'q') {
                unit = unit.toUpperCase();
            } else if (unit === 'Y' || unit === 'H' || unit === 'D') {
                unit = unit.toLowerCase();
            }
            computedDate = date.add(time, unit);
        }
        if (computedDate) {
            computedDate = computedDate._d;
        }
        return computedDate;
    }

    interpret(value: string, date: Date): moment.Moment {
        let result: moment.Moment = null;
        const format = value[0];
        if (format === '*') {
            result = moment();
        }
        return result;
    }

    static isAcceptable(s: string): boolean {
        const result = DatesHelper.isKeyword(s) || DatesHelper.isDate(s);
        return result;
    }

    static isKeyword(s: string): boolean {
        const regex = /^([Ll](-[0-9]+[MmDdHh])?|[Ff](\+[0-9]+[MmDdHh])?|[Bb](\+[0-9]+[MmDdHh])|[Ee](-[0-9]+[MmDdHh])|[\*](-[0-9]+[MmDdHh])?)$/;
        const result = regex.test(s);
        return result;
    }

    static isDate(s: string): boolean {
        const regex = /^([0-9]{4}(-[0-9]{2}){2}( [0-9]{2}:[0-9]{2})?)$/;
        const result = regex.test(s);
        return result;
    }

    static timeUnitToStartOf(timeUnit: TimeUnit): moment.unitOfTime.DurationConstructor {
        let period: moment.unitOfTime.DurationConstructor;
        switch (timeUnit) {
            case TimeUnit.Second:
                period = 's';
                break;
            case TimeUnit.Minute:
                period = 'm';
                break;
            case TimeUnit.Hour:
                period = 'h';
                break;
            case TimeUnit.Day:
                period = 'd';
                break;
            case TimeUnit.Week:
                period = 'w';
                break;
            case TimeUnit.Month:
                period = 'M';
                break;
            case TimeUnit.Year:
                period = 'y';
                break;
        }
        return period;
    }

    private getUtcMoment(dateTime, timeZone, format) {
        let originalMoment = moment(dateTime, format);
        try {
            const offset = this.getOffset(dateTime, timeZone, format);
            originalMoment = originalMoment.add(offset, 'm');
        } catch (e) {

        }
        return originalMoment;
    }

    getOlsonName(timeZone: string) {
        let olsonName = 'Etc/GMT';
        try {
            if (timeZone === null || timeZone === 'UTC') {
                olsonName = 'Etc/GMT';
            } else if (timeZone === 'Local') {
                olsonName = getTimeZone();
            } else {
                olsonName = timeZone;
            }
        } catch (e) {

        }
        return olsonName;
    }

    private getOffset(dateTime: Date, timeZone, format) {
        let offset = 0;
        if (timeZone === 'Etc/GMT') {
            offset = 0;
        } else {
            offset = moment.tz(dateTime.toString(), format, this.getOlsonName(timeZone)).utcOffset();
        }
        return offset;
    }
}